import React from "react";
import { useNavigate } from "react-router-dom";

const AdditionalInfoModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleProceed = () => {
    onClose();
    navigate("/additionalinfo");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-md p-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Additional Information Required
        </h2>
        <p className="text-gray-600 mb-6">
          Please fill in the additional information before proceeding.
        </p>
        <div className="flex justify-end space-x-4">
          <button
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            onClick={handleProceed}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdditionalInfoModal;